import { createRoute, redirect } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'
import { Features } from '@/utils/featureFlag/features'

export const integrationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/integrations',
  beforeLoad: async ({ context, location }) => {
    await ensureAuthenticatedUser({ context, location })
    if (
      (context.isFeatureEnabled && !context.isFeatureEnabled(Features.INTEGRATIONS_ENABLED)) ||
      (context.isReady && !context.isCustomerActive)
    ) {
      throw redirect({
        to: '/',
      })
    }
  },
}).lazy(() => import('./integrations').then((d) => d.Route))
